module.exports = __webpack_public_path__ + "static/media/icon-dribble.c8d853e7.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/homeView/icon-dribble.svg
// module id = 168
// module chunks = 0